import { getTrackingArray } from 'modules/ensighten_tracking/constants/ensightenConstants';

export const trackInteraction = ({ mergedData }) => {
  mergedData.interactionevent = 1;
  getTrackingArray().push({ type: 'interaction', data: mergedData });
};
